import Link from 'next/link'

import { a as A } from './styles'

const AComponent = ({ href, children, ...props }) => {
  const safeHref = typeof href === 'string' ? href : '#'

  return (
    <>
      {safeHref.startsWith('/') ? (
        <Link href={safeHref} {...props}>
          <A>{children}</A>
        </Link>
      ) : safeHref.startsWith('#') ? (
        <A href={safeHref} {...props}>
          {children}
        </A>
      ) : (
        <A href={safeHref} {...props} target="_blank" rel="noreferrer">
          {children}
        </A>
      )}
    </>
  )
}

export default AComponent
